export class TipoComunicado {
  public id!: number;
  public ativo!: boolean;
  public descricao!: string;
}